<div class="card card-statistics mb-30" *ngIf="form">
  <div class="card-body" dir="rtl">
    <div class="form-heading">
      <div>
        <h5 class="card-title">فرم ثبت اطلاعات حجم</h5>
        <p class="text-muted mb-0">
          ثبت اطلاعات کالیبراسیون و عدم قطعیت
        </p>
      </div>

    </div>

    <div *ngIf="isLoadingInitialData" class="certificate-status certificate-status--loading" role="status">
      در حال دریافت اطلاعات گواهی...
    </div>

    <div *ngIf="!isLoadingInitialData && certificateRegistrationMessage" class="certificate-status"
      [class.certificate-status--registered]="certificateRegistrationStatus === 'registered'"
      [class.certificate-status--not-registered]="certificateRegistrationStatus === 'notRegistered'" role="status">
      {{ certificateRegistrationMessage }}
    </div>

    <form [formGroup]="form" [class.form-loading]="isLoadingInitialData" (ngSubmit)="submitForm()" novalidate>
      <fieldset [disabled]="isLoadingInitialData" class="form-loading-fieldset">
        <section class="form-section">
          <h6>General and device information</h6>
          <div class="row">
            <div class="form-group col-md-4">
              <label for="Description">{{ fieldLabels.Description }}</label>
              <input id="Description" type="text" class="form-control" formControlName="Description" />
              <small class="form-text MyErrorRedColor">{{ validationMessage(control('Description')) }}</small>
            </div>
            <div class="form-group col-md-4">
              <label for="Expert">{{ fieldLabels.Expert }}</label>
              <input id="Expert" type="text" class="form-control" formControlName="Expert" />
              <small class="form-text MyErrorRedColor">{{ validationMessage(control('Expert')) }}</small>
            </div>
            <div class="form-group col-md-4 switch-field">
              <label class="d-block">زبان گواهی‌نامه</label>
              <label class="checkbox-label">
                <input type="checkbox" formControlName="Farsi" />
                فارسی
              </label>
            </div>

            <div class="form-group col-md-4">
              <label for="Unit">Unit</label>
              <select class="custom-select" formControlName="Unit">
                <option value="l">l</option>
                <option value="ml">ml</option>
                <option value="μl">μl</option>
              </select>

            </div>
            <div class="form-group col-md-4">
              <label for="UncertaintyFloat">UncertaintyFloat</label>
              <input id="UncertaintyFloat" type="number" step="any" class="form-control"
                formControlName="UncertaintyFloat" />
              <small class="form-text MyErrorRedColor">{{ validationMessage(control('UncertaintyFloat')) }}</small>
            </div>

            <div class="form-group col-md-4">
              <label for="IssueDateMiladi">{{ fieldLabels.IssueDateMiladi }}</label>
              <input id="IssueDateMiladi" type="text" class="form-control" formControlName="IssueDateMiladi"
                placeholder="مثال: 2026-01-25T00:00:00" />
              <small class="form-text MyErrorRedColor">{{ validationMessage(control('IssueDateMiladi')) }}</small>
            </div>
            <div class="form-group col-md-4">
              <label for="CalibrationDateMiladi">{{ fieldLabels.CalibrationDateMiladi }}</label>
              <input id="CalibrationDateMiladi" type="text" class="form-control" formControlName="CalibrationDateMiladi"
                placeholder="مثال: 2026-01-24T00:00:00" />
              <small class="form-text MyErrorRedColor">{{ validationMessage(control('CalibrationDateMiladi')) }}</small>
            </div>
            <div class="form-group col-md-4">
              <label for="RecalibrationDateMiladi">{{ fieldLabels.RecalibrationDateMiladi }}</label>
              <input id="RecalibrationDateMiladi" type="text" class="form-control"
                formControlName="RecalibrationDateMiladi" placeholder="مثال: 2027-01-24T00:00:00" />
              <small class="form-text MyErrorRedColor">{{ validationMessage(control('RecalibrationDateMiladi'))
                }}</small>
            </div>
            <div class="col-12" *ngIf="form.errors && (form.touched || form.dirty)">
              <small class="form-text MyErrorRedColor" *ngIf="form.errors.issueBeforeCalibration">
                Issue date cannot be before the calibration date.
              </small>
              <small class="form-text MyErrorRedColor" *ngIf="form.errors.recalibrationBeforeCalibration">
                Recalibration date cannot be before the calibration date.
              </small>
            </div>

            <div class="form-group col-md-4">
              <label for="Manufacturer">{{ fieldLabels.Manufacturer }}</label>
              <input id="Manufacturer" type="text" class="form-control" formControlName="Manufacturer" />
              <small class="form-text MyErrorRedColor">{{ validationMessage(control('Manufacturer')) }}</small>
            </div>
            <div class="form-group col-md-4">
              <label for="ModelDevice">{{ fieldLabels.ModelDevice }}</label>
              <input id="ModelDevice" type="text" class="form-control" formControlName="ModelDevice" />
              <small class="form-text MyErrorRedColor">{{ validationMessage(control('ModelDevice')) }}</small>
            </div>
            <div class="form-group col-md-4">
              <label for="TypeDevice">{{ fieldLabels.TypeDevice }}</label>
              <input id="TypeDevice" type="text" class="form-control" formControlName="TypeDevice" />
              <small class="form-text MyErrorRedColor">{{ validationMessage(control('TypeDevice')) }}</small>
            </div>
            <div class="form-group col-md-4">
              <label for="CodeNoDevice">{{ fieldLabels.CodeNoDevice }}</label>
              <input id="CodeNoDevice" type="text" class="form-control" formControlName="CodeNoDevice" />
              <small class="form-text MyErrorRedColor">{{ validationMessage(control('CodeNoDevice')) }}</small>
            </div>
            <div class="form-group col-md-4">
              <label for="SerialNoDevice">{{ fieldLabels.SerialNoDevice }}</label>
              <input id="SerialNoDevice" type="text" class="form-control" formControlName="SerialNoDevice" />
              <small class="form-text MyErrorRedColor">{{ validationMessage(control('SerialNoDevice')) }}</small>
            </div>
            <div class="form-group col-md-4">
              <label for="CustomerName">{{ fieldLabels.CustomerName }}</label>
              <input id="CustomerName" type="text" class="form-control" formControlName="CustomerName" />
              <small class="form-text MyErrorRedColor">{{ validationMessage(control('CustomerName')) }}</small>
            </div>
            <div class="form-group col-md-6">
              <label for="CertificateAddress">{{ fieldLabels.CertificateAddress }}</label>
              <textarea id="CertificateAddress" rows="2" class="form-control"
                formControlName="CertificateAddress"></textarea>
              <small class="form-text MyErrorRedColor">{{ validationMessage(control('CertificateAddress')) }}</small>
            </div>
            <div class="form-group col-md-6">
              <label for="LabAdderss">{{ fieldLabels.LabAdderss }}</label>
              <textarea id="LabAdderss" rows="2" class="form-control" formControlName="LabAdderss"></textarea>
              <small class="form-text MyErrorRedColor">{{ validationMessage(control('LabAdderss')) }}</small>
            </div>

            <div class="form-group col-md-3">
              <label>Value</label>
              <input type="number" step="any" class="form-control" formControlName="Value" />
              <small class="form-text MyErrorRedColor">{{ validationMessage(control('Value')) }}</small>
            </div>
            <div class="form-group col-md-3">
              <label>From</label>
              <input type="number" step="any" class="form-control" formControlName="From" />
              <small class="form-text MyErrorRedColor">{{ validationMessage(control('From')) }}</small>
            </div>
            <div class="form-group col-md-3">
              <label>To</label>
              <input type="number" step="any" class="form-control" formControlName="To" />
              <small class="form-text MyErrorRedColor">{{ validationMessage(control('To')) }}</small>
            </div>
            <div class="form-group col-md-3">
              <label>Division</label>
              <input type="number" step="any" min="0" class="form-control" formControlName="Division" />
              <small class="form-text MyErrorRedColor">{{ validationMessage(control('Division')) }}</small>
            </div>
            <div class="col-12" *ngIf="form.errors && form.errors.fromAfterTo">
              <small class="form-text MyErrorRedColor">From must be less than or equal to To.</small>
            </div>
            <div class="form-group col-md-3" style="display: none;">
              <label>LetterId</label>
              <input type="number" step="1" min="0" class="form-control" formControlName="LetterId" />
              <small class="form-text MyErrorRedColor">{{ validationMessage(control('LetterId')) }}</small>
            </div>
            <div class="form-group col-md-3" style="display: none;">
              <label>CalibrationDetailId</label>
              <input type="number" step="1" min="0" class="form-control" formControlName="CalibrationDetailId" />
              <small class="form-text MyErrorRedColor">{{ validationMessage(control('CalibrationDetailId')) }}</small>
            </div>
          </div>
        </section>

        <section class="form-section">
          <h6>Base value containers</h6>
          <div class="row">
            <div class="form-group col-sm-6 col-md-3" *ngFor="let field of valueContainerFields; trackBy: trackByIndex"
              [formGroupName]="field.key">
              <label>
                {{ field.label }}.Value
                <i class="fa fa-info-circle field-help-icon" [attr.title]="fieldHelp[field.key]"></i>
              </label>
              <input type="number" step="any" class="form-control" formControlName="Value" />
              <small class="form-text MyErrorRedColor">
                {{ validationMessage(control(field.key + '.Value')) }}
              </small>
            </div>
          </div>
        </section>

        <section class="form-section unified-measurements" formArrayName="m2">
          <div class="section-heading">
            <h6>اندازه‌گیری‌ها و حدود پذیرش</h6>
            <button type="button" class="btn btn-success btn-sm" (click)="addM2Item()">
              <i class="fa fa-plus-circle"></i> افزودن اندازه‌گیری
            </button>
          </div>

          <article class="array-card unified-measurement-card"
            *ngFor="let measurement of m2.controls; let m2Index = index; trackBy: trackByIndex"
            [attr.data-measurement-index]="m2Index" [formGroupName]="m2Index">
            <header class="array-card-header">
              <button type="button" class="btn btn-link"
                [attr.aria-label]="expandedM2Rows[m2Index] ? 'بستن جزئیات' : 'نمایش جزئیات'"
                [title]="expandedM2Rows[m2Index] ? 'بستن جزئیات' : 'نمایش جزئیات'"
                (click)="expandedM2Rows[m2Index] = !expandedM2Rows[m2Index]">
                <i class="fa" [ngClass]="expandedM2Rows[m2Index] ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
                <i class="fa fa-info-circle field-help-icon" [attr.title]="fieldHelp['m2']"></i>
                اندازه‌گیری شماره {{ m2Index + 1 }} — مقدار: {{ measurement.get('Value').value }}
              </button>
              <button type="button" class="btn btn-danger btn-sm"
                [attr.aria-label]="'حذف اندازه‌گیری شماره ' + (m2Index + 1)"
                [title]="'حذف اندازه‌گیری شماره ' + (m2Index + 1)" (click)="removeM2Item(m2Index)">
                <i class="fa fa-remove"></i> حذف اندازه‌گیری
              </button>
            </header>

            <div *ngIf="expandedM2Rows[m2Index]" class="array-card-body">
              <section class="measurement-information">
                <h6 class="subsection-title">اطلاعات اندازه‌گیری</h6>
                <div class="row">
                  <div class="form-group col-md-4">
                    <label [attr.for]="'uncertainty-evaluation-' + m2Index">ارزیابی عدم قطعیت</label>
                    <select [id]="'uncertainty-evaluation-' + m2Index" class="custom-select"
                      formControlName="UncertaintyEvaluation">
                      <option *ngFor="let option of typeAUncertaintyEvaluationOptions" [ngValue]="option.value">{{
                        option.label }}</option>
                    </select>
                    <small class="form-text MyErrorRedColor">{{
                      validationMessage(measurement.get('UncertaintyEvaluation')) }}</small>
                  </div>
                  <div class="form-group col-md-4">
                    <label [attr.for]="'observation-method-' + m2Index">روش مشاهده</label>
                    <select [id]="'observation-method-' + m2Index" class="custom-select"
                      formControlName="ObservationMethod">
                      <option *ngFor="let option of observationMethodOptions" [ngValue]="option.value">{{ option.label
                        }}</option>
                    </select>
                    <small class="form-text MyErrorRedColor">{{ validationMessage(measurement.get('ObservationMethod'))
                      }}</small>
                  </div>
                  <div class="form-group col-md-4">
                    <label [attr.for]="'uncertainty-estimate-' + m2Index">برآورد عدم قطعیت</label>
                    <select [id]="'uncertainty-estimate-' + m2Index" class="custom-select"
                      formControlName="UncertaintyEstimate">
                      <option *ngFor="let option of typeAUncertaintyEstimateOptions" [ngValue]="option.value">{{
                        option.label }}</option>
                    </select>
                    <small class="form-text MyErrorRedColor">{{
                      validationMessage(measurement.get('UncertaintyEstimate')) }}</small>
                  </div>
                  <div class="form-group col-md-3">
                    <label [attr.for]="'standard-deviation-' + m2Index">انحراف معیار</label>
                    <input [id]="'standard-deviation-' + m2Index" type="number" min="0" step="any" class="form-control"
                      formControlName="StandardDeviation" />
                    <small class="form-text MyErrorRedColor">{{ validationMessage(measurement.get('StandardDeviation'))
                      }}</small>
                  </div>
                  <div class="form-group col-md-3">
                    <label [attr.for]="'measurement-value-' + m2Index">مقدار</label>
                    <input [id]="'measurement-value-' + m2Index" type="number" step="any"
                      class="form-control shared-measurement-value" formControlName="Value" />
                    <small class="form-text MyErrorRedColor">{{ validationMessage(measurement.get('Value')) }}</small>
                  </div>
                  <div class="form-group col-md-3">
                    <label [attr.for]="'measurement-dof-' + m2Index">درجه آزادی</label>
                    <input [id]="'measurement-dof-' + m2Index" type="number" min="0" step="any" class="form-control"
                      formControlName="DoF" [readonly]="isPositiveInfinity(measurement.get('DoF'))" />
                    <label class="checkbox-label mt-1" [attr.for]="'measurement-dof-infinity-' + m2Index">
                      <input [id]="'measurement-dof-infinity-' + m2Index" type="checkbox"
                        [checked]="isPositiveInfinity(measurement.get('DoF'))"
                        (change)="onInfinityToggle(measurement.get('DoF'), $event)" />
                      بی‌نهایت مثبت
                    </label>
                    <small class="form-text MyErrorRedColor">{{ validationMessage(measurement.get('DoF')) }}</small>
                  </div>
                  <div class="form-group col-md-3">
                    <label [attr.for]="'standard-uncertainty-' + m2Index">عدم قطعیت استاندارد</label>
                    <input [id]="'standard-uncertainty-' + m2Index" type="number" min="0" step="any"
                      class="form-control" formControlName="StandardUncertainty" style="display: none;" />
                    <small class="form-text MyErrorRedColor">{{
                      validationMessage(measurement.get('StandardUncertainty')) }}</small>
                  </div>
                  <div class="form-group col-md-4">
                    <label [attr.for]="'sensitivity-coeff-' + m2Index">ضریب حساسیت</label>
                    <input [id]="'sensitivity-coeff-' + m2Index" type="number" step="any" class="form-control"
                      formControlName="SensitivityCoeff" />
                    <small class="form-text MyErrorRedColor">{{ validationMessage(measurement.get('SensitivityCoeff'))
                      }}</small>
                  </div>
                  <div class="form-group col-md-4">
                    <label [attr.for]="'uncertainty-contribution-' + m2Index">سهم عدم قطعیت</label>
                    <input [id]="'uncertainty-contribution-' + m2Index" type="number" step="any" class="form-control"
                      formControlName="UncertaintyContribution" />
                    <small class="form-text MyErrorRedColor">{{
                      validationMessage(measurement.get('UncertaintyContribution')) }}</small>
                  </div>
                  <div class="form-group col-md-4">
                    <label [attr.for]="'relative-contribution-' + m2Index">سهم نسبی</label>
                    <input [id]="'relative-contribution-' + m2Index" type="number" step="any" class="form-control"
                      formControlName="RelativeContribution" />
                    <small class="form-text MyErrorRedColor">{{
                      validationMessage(measurement.get('RelativeContribution')) }}</small>
                  </div>
                </div>

                <div class="observation-editor" [class.active-editor]="isObservationMethod(m2Index, 0)"
                  formArrayName="Observations">
                  <div class="section-heading">
                    <strong>مشاهدات</strong>
                    <button type="button" class="btn btn-outline-success btn-sm" (click)="addObservation(m2Index)">
                      <i class="fa fa-plus"></i> افزودن مشاهده
                    </button>
                  </div>
                  <p class="empty-message" *ngIf="observations(m2Index).length === 0">مشاهده‌ای ثبت نشده است.</p>
                  <div class="row">
                    <div class="form-group col-sm-6 col-md-3 observation-control"
                      *ngFor="let observation of observations(m2Index).controls; let observationIndex = index; trackBy: trackByIndex">
                      <label [attr.for]="'observation-' + m2Index + '-' + observationIndex">مشاهده {{ observationIndex +
                        1 }}</label>
                      <div class="input-group">
                        <input [id]="'observation-' + m2Index + '-' + observationIndex" type="number" step="any"
                          class="form-control" [formControlName]="observationIndex" />
                        <div class="input-group-append">
                          <button type="button" class="btn btn-outline-danger"
                            [attr.aria-label]="'حذف مشاهده شماره ' + (observationIndex + 1)"
                            [title]="'حذف مشاهده شماره ' + (observationIndex + 1)"
                            (click)="removeObservation(m2Index, observationIndex)">
                            <i class="fa fa-remove"></i>
                          </button>
                        </div>
                      </div>
                      <small class="form-text MyErrorRedColor">{{ validationMessage(observation) }}</small>
                    </div>
                  </div>
                </div>

                <div class="observation-editor" [class.active-editor]="isObservationMethod(m2Index, 1)"
                  formArrayName="IndirectObservations">
                  <div class="section-heading">
                    <strong>مشاهدات غیرمستقیم</strong>
                    <button type="button" class="btn btn-outline-success btn-sm"
                      (click)="addIndirectObservation(m2Index)">
                      <i class="fa fa-plus"></i> افزودن مشاهده غیرمستقیم
                    </button>
                  </div>
                  <p class="empty-message" *ngIf="indirectObservations(m2Index).length === 0">مشاهده غیرمستقیمی ثبت نشده
                    است.</p>
                  <div class="row">
                    <div class="form-group col-sm-6 col-md-3 observation-control"
                      *ngFor="let observation of indirectObservations(m2Index).controls; let observationIndex = index; trackBy: trackByIndex">
                      <label [attr.for]="'indirect-observation-' + m2Index + '-' + observationIndex">مشاهده {{
                        observationIndex + 1 }}</label>
                      <div class="input-group">
                        <input [id]="'indirect-observation-' + m2Index + '-' + observationIndex" type="number"
                          step="any" class="form-control" [formControlName]="observationIndex" />
                        <div class="input-group-append">
                          <button type="button" class="btn btn-outline-danger"
                            [attr.aria-label]="'حذف مشاهده غیرمستقیم شماره ' + (observationIndex + 1)"
                            [title]="'حذف مشاهده غیرمستقیم شماره ' + (observationIndex + 1)"
                            (click)="removeIndirectObservation(m2Index, observationIndex)">
                            <i class="fa fa-remove"></i>
                          </button>
                        </div>
                      </div>
                      <small class="form-text MyErrorRedColor">{{ validationMessage(observation) }}</small>
                    </div>
                  </div>
                </div>
              </section>

              <section class="paired-nmodel-section" [formGroup]="getNModelGroup(m2Index)">
                <h6 class="subsection-title">حدود، تلرانس و قانون تصمیم‌گیری</h6>
                <div class="row">
                  <div class="form-group col-md-2">
                    <label [attr.for]="'nmodel-tolerance-' + m2Index">تلرانس</label>
                    <input [id]="'nmodel-tolerance-' + m2Index" type="number" min="0" step="any" class="form-control"
                      formControlName="Tolerance" />
                    <small class="form-text MyErrorRedColor">{{
                      validationMessage(getNModelGroup(m2Index).get('Tolerance')) }}</small>
                  </div>
                  <div class="form-group col-md-2">
                    <label [attr.for]="'nmodel-tur-' + m2Index">TUR</label>
                    <input [id]="'nmodel-tur-' + m2Index" type="number" min="0" step="any" class="form-control"
                      formControlName="TUR" />
                    <small class="form-text MyErrorRedColor">{{ validationMessage(getNModelGroup(m2Index).get('TUR'))
                      }}</small>
                  </div>
                  <div class="form-group col-md-2">
                    <label [attr.for]="'nmodel-limit-value-' + m2Index">LimitValue</label>
                    <input [id]="'nmodel-limit-value-' + m2Index" type="number" min="0" step="any" class="form-control"
                      formControlName="LimitValue" />
                    <small class="form-text MyErrorRedColor">{{
                      validationMessage(getNModelGroup(m2Index).get('LimitValue')) }}</small>
                  </div>
                  <div class="form-group col-md-2">
                    <label [attr.for]="'nmodel-limit-' + m2Index">حد پذیرش</label>
                    <input [id]="'nmodel-limit-' + m2Index" type="number" min="0" step="any" class="form-control"
                      formControlName="Limit" />
                    <small class="form-text MyErrorRedColor">{{ validationMessage(getNModelGroup(m2Index).get('Limit'))
                      }}</small>
                  </div>
                  <div class="form-group col-md-2">
                    <label [attr.for]="'nmodel-lower-limit-' + m2Index">حد پایین</label>
                    <input [id]="'nmodel-lower-limit-' + m2Index" type="number" step="any" class="form-control"
                      formControlName="LowerLimit" />
                    <small class="form-text MyErrorRedColor">{{
                      validationMessage(getNModelGroup(m2Index).get('LowerLimit')) }}</small>
                  </div>
                  <div class="form-group col-md-2">
                    <label [attr.for]="'nmodel-upper-limit-' + m2Index">حد بالا</label>
                    <input [id]="'nmodel-upper-limit-' + m2Index" type="number" step="any" class="form-control"
                      formControlName="UpperLimit" />
                    <small class="form-text MyErrorRedColor">{{
                      validationMessage(getNModelGroup(m2Index).get('UpperLimit')) }}</small>
                  </div>
                  <div class="form-group col-md-4">
                    <label [attr.for]="'nmodel-decision-rule-' + m2Index">قانون تصمیم‌گیری</label>
                    <select [id]="'nmodel-decision-rule-' + m2Index" class="custom-select"
                      formControlName="DecisionRule">
                      <option *ngFor="let rule of decisionRules" [ngValue]="rule.value">{{ rule.label }}</option>
                    </select>
                    <small class="form-text MyErrorRedColor">{{
                      validationMessage(getNModelGroup(m2Index).get('DecisionRule')) }}</small>
                  </div>
                  <div class="col-12"
                    *ngIf="getNModelGroup(m2Index).errors && getNModelGroup(m2Index).errors.limitsOrder">
                    <small class="form-text MyErrorRedColor">حد پایین باید کوچک‌تر یا مساوی حد بالا باشد.</small>
                  </div>
                  <div class="col-12">
                    <ng-container *ngTemplateOutlet="distributionEditor; context: {
                      $implicit: getNModelGroup(m2Index).get('Distribution'),
                      idPrefix: 'nmodel-distribution-' + m2Index
                    }">
                    </ng-container>
                  </div>
                </div>
              </section>
            </div>
          </article>
        </section>

        <section class="form-section" *ngIf="nModels.length > m2.length" formArrayName="NModels">
          <h6>NModels</h6>
          <ng-container *ngFor="let nModel of nModels.controls; let nModelIndex = index; trackBy: trackByIndex">
            <article class="array-card paired-nmodel-section" *ngIf="nModelIndex >= m2.length"
              [formGroupName]="nModelIndex">
              <div class="array-card-header static"><strong>NModel {{ nModelIndex + 1 }}</strong></div>
              <div class="array-card-body row">
                <div class="form-group col-md-2"><label>Value</label><input class="form-control"
                    formControlName="Value" /></div>
                <div class="form-group col-md-2"><label>Tolerance</label><input type="number" class="form-control"
                    formControlName="Tolerance" /></div>
                <div class="form-group col-md-2"><label>TUR</label><input type="number" class="form-control"
                    formControlName="TUR" /></div>
                <div class="form-group col-md-2"><label>LimitValue</label><input type="number" class="form-control"
                    formControlName="LimitValue" /></div>
                <div class="form-group col-md-2"><label>Limit</label><input type="number" class="form-control"
                    formControlName="Limit" /></div>
                <div class="form-group col-md-2"><label>LowerLimit</label><input type="number" class="form-control"
                    formControlName="LowerLimit" /></div>
                <div class="form-group col-md-2"><label>UpperLimit</label><input type="number" class="form-control"
                    formControlName="UpperLimit" /></div>
                <div class="form-group col-md-2"><label>قانون تصمیم‌گیری</label><select class="custom-select"
                    formControlName="DecisionRule"><option *ngFor="let rule of decisionRules" [ngValue]="rule.value">{{ rule.label }}</option></select></div>
                <div class="col-12">
                  <ng-container
                    *ngTemplateOutlet="distributionEditor; context: { $implicit: nModel.get('Distribution'), idPrefix: 'extra-nmodel-distribution-' + nModelIndex }"></ng-container>
                </div>
              </div>
            </article>
          </ng-container>
        </section>

        <section class="form-section">
          <h6>Uncertainty objects</h6>
          <div class="array-card uncertainty-card" *ngFor="let section of uncertaintySections; trackBy: trackByIndex"
            [formGroupName]="section.key">
            <div class="array-card-header static">
              <strong>
                {{ section.label }}
                <i class="fa fa-info-circle field-help-icon" [attr.title]="fieldHelp[section.key]"></i>
              </strong>
            </div>
            <div class="array-card-body">
              <div class="row">
                <div class="col-12">
                  <ng-container *ngTemplateOutlet="distributionEditor; context: {
                    $implicit: control(section.key + '.Distribution'),
                    idPrefix: section.key + '-distribution'
                  }">
                  </ng-container>
                </div>

                <ng-container *ngIf="section.kind === 'limit'">
                  <div class="form-group col-md-3">
                    <label>HalfWidthOfLimit</label>
                    <input type="number" min="0" step="any" class="form-control" formControlName="HalfWidthOfLimit" />
                    <small class="form-text MyErrorRedColor">{{ validationMessage(control(section.key +
                      '.HalfWidthOfLimit')) }}</small>
                  </div>
                  <div class="form-group col-md-3">
                    <label>RelativeErrorOfUncertainty</label>
                    <input type="number" min="0" step="any" class="form-control"
                      formControlName="RelativeErrorOfUncertainty" />
                    <small class="form-text MyErrorRedColor">{{ validationMessage(control(section.key +
                      '.RelativeErrorOfUncertainty')) }}</small>
                  </div>
                </ng-container>

                <ng-container *ngIf="section.kind === 'expanded'">
                  <div class="form-group col-md-3">
                    <label>ExpandedUncertainty</label>
                    <input type="number" min="0" step="any" class="form-control"
                      formControlName="ExpandedUncertainty" />
                    <small class="form-text MyErrorRedColor">{{ validationMessage(control(section.key +
                      '.ExpandedUncertainty')) }}</small>
                  </div>
                  <div class="form-group col-md-3">
                    <label>CoverageFactor</label>
                    <input type="number" min="0" step="any" class="form-control" formControlName="CoverageFactor" />
                    <small class="form-text MyErrorRedColor">{{ validationMessage(control(section.key +
                      '.CoverageFactor')) }}</small>
                  </div>
                </ng-container>

                <div class="form-group col-md-3">
                  <label>DoF</label>
                  <input type="number" min="0" step="any" class="form-control" formControlName="DoF"
                    [readonly]="isPositiveInfinity(control(section.key + '.DoF'))" />
                  <label class="checkbox-label mt-1">
                    <input type="checkbox" [checked]="isPositiveInfinity(control(section.key + '.DoF'))"
                      (change)="onInfinityToggle(control(section.key + '.DoF'), $event)" />
                    Positive Infinity
                  </label>
                  <small class="form-text MyErrorRedColor">{{ validationMessage(control(section.key + '.DoF'))
                    }}</small>
                </div>
                <div class="form-group col-md-3">
                  <label>Value</label>
                  <input type="number" step="any" class="form-control" formControlName="Value" />
                  <small class="form-text MyErrorRedColor">{{ validationMessage(control(section.key + '.Value'))
                    }}</small>
                </div>
                <div class="form-group col-md-3" style="display: none;">
                  <label>StandardUncertainty</label>
                  <input type="number" min="0" step="any" class="form-control" formControlName="StandardUncertainty"
                    [readonly]="section.allowInfiniteStandardUncertainty && isPositiveInfinity(control(section.key + '.StandardUncertainty'))" />
                  <label class="checkbox-label mt-1" *ngIf="section.allowInfiniteStandardUncertainty">
                    <input type="checkbox" [checked]="isPositiveInfinity(control(section.key + '.StandardUncertainty'))"
                      (change)="onInfinityToggle(control(section.key + '.StandardUncertainty'), $event)" />
                    Positive Infinity
                  </label>
                  <small class="form-text MyErrorRedColor">{{ validationMessage(control(section.key +
                    '.StandardUncertainty')) }}</small>
                </div>
                <div class="form-group col-md-3">
                  <label>SensitivityCoeff</label>
                  <input type="number" step="any" class="form-control" formControlName="SensitivityCoeff" />
                  <small class="form-text MyErrorRedColor">{{ validationMessage(control(section.key +
                    '.SensitivityCoeff')) }}</small>
                </div>
                <div class="form-group col-md-3">
                  <label>UncertaintyContribution</label>
                  <input type="number" step="any" class="form-control" formControlName="UncertaintyContribution" />
                  <small class="form-text MyErrorRedColor">{{ validationMessage(control(section.key +
                    '.UncertaintyContribution')) }}</small>
                </div>
                <div class="form-group col-md-3">
                  <label>RelativeContribution</label>
                  <input type="number" step="any" class="form-control" formControlName="RelativeContribution" />
                  <small class="form-text MyErrorRedColor">{{ validationMessage(control(section.key +
                    '.RelativeContribution')) }}</small>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div class="form-actions">
          <button type="submit" class="btn btn-success"
            [disabled]="form.invalid || isSubmitting || isLoadingInitialData">
            <ng-container *ngIf="!isSubmitting">
              <i class="fa fa-check"></i> ثبت اطلاعات
            </ng-container>
            <ng-container *ngIf="isSubmitting">
              <i class="fa fa-spin fa-spinner"></i> در حال ثبت...
            </ng-container>
          </button>
          <button type="button" class="btn btn-danger" [disabled]="isSubmitting || isLoadingInitialData"
            (click)="resetToDefault()">
            <i class="fa fa-refresh"></i> بازنشانی فرم
          </button>
          <button routerLink="/KartableInbox" [disabled]="isSubmitting || isLoadingInitialData" type="button"
            style="margin-left: 5px;" class="btn btn-warning"><i class="fa fa-mail-reply"></i> بازگشت </button>
        </div>
      </fieldset>
    </form>

    <app-data-entity-volume-certificate-result [certificate]="certificate" [certificateFilePath]="certificateFilePath"
      [uncertaintyReportFilePath]="uncertaintyReportFilePath" [isDownloading]="isDownloadingCertificate"
      [isDownloadingUncertaintyReport]="isDownloadingUncertaintyReport" (download)="downloadCertificateFile()"
      (downloadUncertaintyReport)="downloadUncertaintyReportFile()">
    </app-data-entity-volume-certificate-result>

    <section *ngIf="false && (certificate || certificateFilePath)" class="certificate-result-card"
      aria-labelledby="certificate-result-title">
      <header class="certificate-result-card__header">
        <div>
          <h2 id="certificate-result-title">نتیجه گواهی</h2>
          <p>اطلاعات محاسبات و نتیجه نهایی گواهی</p>
        </div>

        <button *ngIf="certificateFilePath" type="button" class="btn btn-primary certificate-download-button"
          [disabled]="isDownloadingCertificate" aria-label="دانلود فایل Word گواهی" (click)="downloadCertificateFile()">
          <i class="fa" [ngClass]="isDownloadingCertificate ? 'fa-spin fa-spinner' : 'fa-file-word-o'">
          </i>
          {{
          isDownloadingCertificate
          ? 'در حال دریافت فایل...'
          : 'دانلود فایل Word گواهی'
          }}
        </button>
      </header>

      <ng-container *ngIf="certificate as cert; else certificateFileOnly">
        <div class="certificate-summary-grid">
          <div class="certificate-summary-item">
            <span>نام گواهی</span>
            <strong>{{ cert.name || '—' }}</strong>
          </div>
          <div class="certificate-summary-item">
            <span>شرح گواهی</span>
            <strong>{{ cert.description || '—' }}</strong>
          </div>
          <div class="certificate-summary-item">
            <span>تعداد نتایج محاسبات</span>
            <strong>{{ cert.formulas.length }}</strong>
          </div>
          <div class="certificate-summary-item">
            <span>وضعیت فایل گواهی</span>
            <strong>
              {{
              certificateFilePath
              ? 'فایل گواهی آماده دانلود است'
              : 'فایل گواهی هنوز ایجاد نشده است'
              }}
            </strong>
          </div>
        </div>

        <p class="empty-message certificate-empty-message" *ngIf="cert.formulas.length === 0">
          نتیجه محاسباتی برای نمایش وجود ندارد.
        </p>

        <article class="certificate-formula-card"
          *ngFor="let formula of cert.formulas; let formulaIndex = index; trackBy: trackByIndex">
          <header class="certificate-formula-card__header">
            <h3>نتیجه اندازه‌گیری شماره {{ formulaIndex + 1 }}</h3>
            <span>{{ formula.result?.name || formula.name || '—' }}</span>
          </header>

          <ng-container *ngIf="formula.result as result; else missingFormulaResult">
            <div class="certificate-result-grid">
              <div>
                <span>نام نتیجه</span>
                <strong>{{ result.name || formula.name || '—' }}</strong>
              </div>
              <div>
                <span>مقدار محاسبه‌شده</span>
                <strong>{{ formatNumericValue(result.value) }}</strong>
              </div>
              <div>
                <span>عدم قطعیت استاندارد</span>
                <strong>{{ formatNumericValue(result.standardUncertainty) }}</strong>
              </div>
              <div>
                <span>عدم قطعیت گسترده</span>
                <strong>{{ formatNumericValue(result.expandedUncertainty) }}</strong>
              </div>
              <div>
                <span>درجه آزادی</span>
                <strong>{{ formatNumericValue(result.doF) }}</strong>
              </div>
              <div>
                <span>واحد</span>
                <strong>{{ result.unit || '—' }}</strong>
              </div>
              <div>
                <span>وضعیت قابلیت</span>
                <strong class="certificate-result-badge"
                  [ngClass]="getAcceptanceClass(result.capabilityProof?.acceptance)">
                  {{ getAcceptanceLabel(result.capabilityProof?.acceptance) }}
                </strong>
              </div>
              <div>
                <span>وضعیت انطباق</span>
                <strong class="certificate-result-badge"
                  [ngClass]="getAcceptanceClass(result.complianceAssessment?.acceptance)">
                  {{ getAcceptanceLabel(result.complianceAssessment?.acceptance) }}
                </strong>
              </div>
            </div>

            <div class="certificate-status-panels">
              <section class="certificate-status-panel" *ngIf="result.capabilityProof as capabilityProof">
                <h4>اثبات قابلیت</h4>
                <dl>
                  <div>
                    <dt>تلرانس</dt>
                    <dd>{{ formatNumericValue(capabilityProof.tolerance) }}</dd>
                  </div>
                  <div>
                    <dt>حد قابلیت</dt>
                    <dd>{{ formatNumericValue(capabilityProof.limit) }}</dd>
                  </div>
                  <div>
                    <dt>شاخص قابلیت</dt>
                    <dd>{{ formatNumericValue(capabilityProof.index) }}</dd>
                  </div>
                  <div>
                    <dt>نتیجه قابلیت</dt>
                    <dd class="certificate-result-badge" [ngClass]="getAcceptanceClass(capabilityProof.acceptance)">
                      {{ getAcceptanceLabel(capabilityProof.acceptance) }}
                    </dd>
                  </div>
                </dl>
              </section>

              <section class="certificate-status-panel" *ngIf="result.complianceAssessment as complianceAssessment">
                <h4>ارزیابی انطباق</h4>
                <dl>
                  <div>
                    <dt>قانون تصمیم‌گیری</dt>
                    <dd>{{ formatNumericValue(complianceAssessment.decisionRule) }}</dd>
                  </div>
                  <div>
                    <dt>حد پایین</dt>
                    <dd>{{ formatNumericValue(complianceAssessment.lowerLimit) }}</dd>
                  </div>
                  <div>
                    <dt>حد بالا</dt>
                    <dd>{{ formatNumericValue(complianceAssessment.upperLimit) }}</dd>
                  </div>
                  <div>
                    <dt>احتمال داخل محدوده</dt>
                    <dd>{{ formatNumericValue(complianceAssessment.insideProbability) }}</dd>
                  </div>
                  <div>
                    <dt>احتمال خارج محدوده</dt>
                    <dd>{{ formatNumericValue(complianceAssessment.outsideProbability) }}</dd>
                  </div>
                  <div>
                    <dt>نتیجه انطباق</dt>
                    <dd class="certificate-result-badge"
                      [ngClass]="getAcceptanceClass(complianceAssessment.acceptance)">
                      {{ getAcceptanceLabel(complianceAssessment.acceptance) }}
                    </dd>
                  </div>
                </dl>
              </section>
            </div>
          </ng-container>

          <ng-template #missingFormulaResult>
            <p class="empty-message">نتیجه محاسبه برای این اندازه‌گیری موجود نیست.</p>
          </ng-template>

          <details class="certificate-details" *ngIf="formula.value || formula.subValues.length">
            <summary>نمایش فرمول و جزئیات محاسبات</summary>
            <div class="formula-expression" *ngIf="formula.value">
              <span>فرمول</span>
              <code dir="ltr">{{ formula.value }}</code>
            </div>
            <div class="formula-expression" *ngIf="formula.subValues.length">
              <span>مقادیر فرعی</span>
              <code dir="ltr" *ngFor="let subValue of formula.subValues; trackBy: trackByIndex">
                {{ subValue }}
              </code>
            </div>
          </details>

          <details class="certificate-details" *ngIf="hasTechnicalSection(formula.parameters)">
            <summary>پارامترهای محاسبه</summary>
            <dl class="certificate-technical-list">
              <div *ngFor="let item of toDisplayEntries(formula.parameters); trackBy: trackByIndex">
                <dt>{{ item.key }}</dt>
                <dd>{{ formatTechnicalValue(item.value) }}</dd>
              </div>
            </dl>
          </details>

          <details class="certificate-details" *ngIf="hasTechnicalSection(formula.constants)">
            <summary>ثابت‌های محاسبه</summary>
            <dl class="certificate-technical-list">
              <div *ngFor="let item of toDisplayEntries(formula.constants); trackBy: trackByIndex">
                <dt>{{ item.key }}</dt>
                <dd>{{ formatTechnicalValue(item.value) }}</dd>
              </div>
            </dl>
          </details>

          <details class="certificate-details" *ngIf="hasTechnicalSection(formula.distribution)">
            <summary>توزیع</summary>
            <dl class="certificate-technical-list">
              <div *ngFor="let item of toDisplayEntries(formula.distribution); trackBy: trackByIndex">
                <dt>{{ item.key }}</dt>
                <dd>{{ formatTechnicalValue(item.value) }}</dd>
              </div>
            </dl>
          </details>

          <details class="certificate-details" *ngIf="hasTechnicalSection(formula.regression)">
            <summary>رگرسیون</summary>
            <dl class="certificate-technical-list">
              <div *ngFor="let item of toDisplayEntries(formula.regression); trackBy: trackByIndex">
                <dt>{{ item.key }}</dt>
                <dd>{{ formatTechnicalValue(item.value) }}</dd>
              </div>
            </dl>
          </details>

          <details class="certificate-details" *ngIf="hasTechnicalSection(formula.monteCarloSimulation)">
            <summary>شبیه‌سازی مونت‌کارلو</summary>
            <dl class="certificate-technical-list">
              <div *ngFor="let item of toDisplayEntries(formula.monteCarloSimulation); trackBy: trackByIndex">
                <dt>{{ item.key }}</dt>
                <dd>{{ formatTechnicalValue(item.value) }}</dd>
              </div>
            </dl>
          </details>
        </article>

        <details class="certificate-details" *ngIf="hasTechnicalSection(cert.regression)">
          <summary>رگرسیون</summary>
          <dl class="certificate-technical-list">
            <div *ngFor="let item of toDisplayEntries(cert.regression); trackBy: trackByIndex">
              <dt>{{ item.key }}</dt>
              <dd>{{ formatTechnicalValue(item.value) }}</dd>
            </div>
          </dl>
        </details>
      </ng-container>

      <ng-template #certificateFileOnly>
        <div class="certificate-file-only">
          <strong>فایل گواهی آماده دانلود است.</strong>
          <span>جزئیات محاسباتی گواهی در پاسخ موجود نیست.</span>
        </div>
      </ng-template>
    </section>
  </div>
</div>

<ng-template #distributionEditor let-distributionGroup let-idPrefix="idPrefix">
  <fieldset class="distribution-editor" [formGroup]="distributionGroup">
    <legend>توزیع</legend>
    <div class="row">
      <div class="form-group col-md-4">
        <label [attr.for]="idPrefix + '-type'">نوع توزیع (<code>$type</code>)</label>
        <select [id]="idPrefix + '-type'" class="custom-select" formControlName="$type">
          <option *ngFor="let distributionType of distributionTypes" [ngValue]="distributionType">
            {{ distributionLabels[distributionType] }}
          </option>
        </select>
        <small class="form-text MyErrorRedColor">{{ validationMessage(distributionGroup.get('$type')) }}</small>
      </div>
      <div class="form-group col-md-4">
        <label [attr.for]="idPrefix + '-coverage-factor'">ضریب پوشش</label>
        <input [id]="idPrefix + '-coverage-factor'" type="number" min="0" step="any" class="form-control"
          formControlName="CoverageFactor" />
        <small class="form-text MyErrorRedColor">{{ validationMessage(distributionGroup.get('CoverageFactor'))
          }}</small>
      </div>
      <div class="form-group col-md-4">
        <label [attr.for]="idPrefix + '-shape-factor'">ضریب شکل</label>
        <input [id]="idPrefix + '-shape-factor'" type="number" min="0" step="any" class="form-control"
          formControlName="ShapeFactor" />
        <small class="form-text MyErrorRedColor">{{ validationMessage(distributionGroup.get('ShapeFactor')) }}</small>
      </div>
    </div>
  </fieldset>
</ng-template>
